<div *ngIf="adminSetup" class="container-fluid">
  <app-header titleText="{{pageTitle}}" isAdmin="true">
    <div account>
      <img src="assets/img/circle_images/admin_circle.png" class="account-image" width="60" alt="My Account Icon" />
      <label class="text-bidit-account-header" i18n>My Account</label>
    </div>
    <div button>
      <a routerLink="/admin/account" class="btn btn-bidit-navigate btn-sm account-button" i18n>Edit Account</a><br />
      <a href="assets/pdf/BIDIT Onboarding.pdf" class="btn btn-bidit-navigate btn-sm"
         target="_blank" download i18n>Onboarding Instructions</a>
    </div>
  </app-header>
  <div class="">
    <h4 class="text-bidit-account-header" i18n>Admin</h4>
    <p class="text-bidit-primary font-weight-bold" i18n>Set up and modify all aspects of your business. Pending items to complete are shown in each area to guide you.</p>
  </div>
  <div class="card-deck container">
    <div class="card bg-light text-white" (click)="projectManagement()">
      <div class="card-header border-0 bg-light">
        <img *ngIf="adminSetup?.projectManagementSetupAreas?.length > 0" class="float-right" src="assets/img/admin/minus.png" width="50" />
        <img *ngIf="adminSetup?.projectManagementSetupAreas?.length == 0" class="float-right" src="assets/img/admin/checkmark.png" width="50" />
      </div>
      <div class="row mb-4 no-gutters">
        <div class="ml-1 ml-sm-2 ml-lg-5">
          <img class="text" src="assets/img/admin/clipboard.png" width="100" />
        </div>
        <div class="col-8 col-lg-7">
          <div class="card-body">
            <h4 class="text-white" i18n>PROJECT MANAGEMENT</h4>
          </div>
        </div>
      </div>
      <div *ngIf="adminSetup.projectManagementSetupAreas.length > 0" class="card-footer border-top-0">
        <div class="bg-white text-danger">
          <h4 class="text-center"> You have {{adminSetup.projectManagementSetupAreas.length}} more steps to complete</h4>
          <ul class="form-inline">
            <li class="ml-3 mr-2" *ngFor='let adminArea of adminSetup.projectManagementSetupAreas'>{{adminArea}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card bg-dark text-white" (click)="businessManagement()">
      <div class="card-header  border-0  bg-dark">
        <img *ngIf="adminSetup.businessManagementSetupAreas.length > 0" class="float-right" src="assets/img/admin/minus.png" width="50" />
        <img *ngIf="adminSetup.businessManagementSetupAreas.length == 0" class="float-right" src="assets/img/admin/checkmark.png" width="50" />
      </div>
      <div class="row mb-4 no-gutters">
        <div class="ml-1 ml-sm-2 ml-lg-5">
          <img class="" src="assets/img/admin/management.png" width="100" />
        </div>
        <div class="col-8 col-lg-7">
          <div class="card-body">
            <div>
              <h4 class="text-white" i18n>BUSINESS MANAGEMENT</h4>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="adminSetup.businessManagementSetupAreas.length > 0" class="card-footer border-top-0">
        <div class="bg-white text-danger">
          <h4 class="text-center"> You have {{adminSetup.businessManagementSetupAreas.length}} more steps to complete</h4>
          <ul class="form-inline">
            <li class="ml-3 mr-2" *ngFor='let adminArea of adminSetup.businessManagementSetupAreas'>{{adminArea}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>  
</div>
